import {MessageCircle, Send} from 'lucide-react';

const MessageInput = ({ 
  inputMessage, 
  setInputMessage, 
  onSendMessage, 
  onStartNewChat,
  isTyping, 
  primaryColor,
  chatState
}) => {
  
  if (chatState === 'ended') {
    return (
      <div className="p-4 border-t bg-white">
        <button
          onClick={onStartNewChat}
          className="w-full py-3 px-4 rounded-lg text-white font-semibold 
                     flex items-center justify-center gap-2 
                     hover:opacity-90 transition-opacity"
          style={{ backgroundColor: primaryColor }}
        >
          <MessageCircle className="w-5 h-5" />
          Iniciar Nova Conversa
        </button>
        
        {/* Rodapé "Desenvolvido por" */}
        <div className="flex justify-center mt-4">
          <a 
            href="https://solteozap.com.br" 
            target="_blank" 
            rel="noopener noreferrer"
            className="text-xs text-gray-500 hover:text-gray-700 flex items-center gap-1"
          >
            <span>Desenvolvido por</span>
            <span className="font-semibold">{window.location.origin === "https://ia.solteozap.com.br" ? "Solte o Zap" : "QuoraAI"}</span>
          </a>
        </div>
      </div>
    );
  }

  return (
    <div className="p-4 border-t bg-white">
      <form onSubmit={(e) => {
        e.preventDefault();
        if (inputMessage.trim() && !isTyping) {
          onSendMessage(inputMessage);
        }
      }} className="flex gap-2">
        <input
          type="text"
          value={inputMessage}
          onChange={(e) => setInputMessage(e.target.value)}
          placeholder="Digite sua mensagem"
          disabled={isTyping || chatState === 'ended'}
          className="flex-1 px-4 py-2.5 border rounded-lg 
                     focus:outline-none focus:ring-2 focus:border-transparent
                     disabled:opacity-50 disabled:cursor-not-allowed text-sm"
          style={{ 
            focusRingColor: primaryColor,
            borderColor: '#E5E7EB'
          }}
        />
        <button
          type="submit"
          disabled={isTyping || !inputMessage.trim() || chatState === 'ended'}
          className="px-4 py-2.5 rounded-lg text-white 
                     disabled:opacity-50 disabled:cursor-not-allowed
                     hover:opacity-90 transition-opacity"
          style={{ backgroundColor: primaryColor }}
        >
          <Send className="w-5 h-5" />
        </button>
      </form>
      
      {/* Rodapé "Desenvolvido por" */}
      <div className="flex justify-center mt-4">
        <a 
          href="https://solteozap.com.br" 
          target="_blank" 
          rel="noopener noreferrer"
          className="text-xs text-gray-500 hover:text-gray-700 flex items-center gap-1"
        >
          <span>Desenvolvido por</span>
          <span className="font-semibold">{window.location.origin === "https://ia.solteozap.com.br" ? "Solte o Zap" : "QuoraAI"}</span>
        </a>
      </div>
    </div>
  );
};

export default MessageInput;